export const getClassName = (additionalClassName?: string) => {
  const className = "material-icons";

  if (additionalClassName) return className + " " + additionalClassName;

  return className;
};
